<template>
    <div class="title-full-stripe">
        <div class="container d-flex h-100">
            <div class="row w-100 justify-content-center align-self-center">
                <div class="col">
                    {{ title }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            title: String
        }
    }
</script>
<style lang="scss">

    @import "../../sass/variables";

    .title-full-stripe {
        background-color: $blue;
        color: #ffffff;
        text-align: center;
        height: 44px;
        font-size: 1.2rem;
        font-weight: 500;
    }

</style>
